<template>
  <div v-if='hasNote()'>
    <TinyMCE v-model='note' :editor-id='editorId' :editor-height='250' @textChanged='onTextChange' @loaded='loaded'/>
    <ModalConfirmDialog></ModalConfirmDialog>
  </div>
</template>

<script>
import ModalConfirmDialog from '@/components/ModalConfirmDialog';
import dayjs from 'dayjs';
import { EventBus, EVENTS } from '@/libs/eventBus';
import TinyMCE from '@/components/TinyMCE';

export default {
  name: 'InterviewNote',
  components: {
    TinyMCE,
    ModalConfirmDialog,
  },
  props: ['note', 'currentPage', 'lastNoteUpdate', 'editorId'],
  data: () => ({
    penInkFormat: 'html',
    currentNote: {},
    businessLogic: {}
  }),
  watch: {},
  methods: {
    loaded(editorId) {
      console.log('loaded:', editorId)
    },
    onTextChange() {
      EventBus.$emit(EVENTS.RESTART_SYNC);
    },
    hasNote() {
      console.log('calling has note', 'result: ', this.note && typeof this.note?.html === 'string');
      return this.note && typeof this.note?.html === 'string'
    }
  },
  mounted() {

  },
}
</script>

<style scoped>

</style>
